import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '10px'
  },

  tabs: {
    marginTop: '-23px',
    marginBottom: '10px',

    [theme.breakpoints.down('md')]: {
      marginTop: '0.5rem'
    }
  },

  tab: {
    fontSize: theme.size.sm
  },

  inputHolder: {
    display: 'flex',
    alignItems: 'center',
    width: '100%'
  },

  input: {
    flex: '1',
    marginTop: '4px',

    '& .text': {
      maxWidth: 'calc(100vw - 12rem)',

      [theme.breakpoints.up('md')]: {
        maxWidth: 'calc(100vw - 22rem)'
      }
    }
  },

  comments: {
    padding: '10px 5px'
  }
}))

export default useStyles
